import { data } from '../../svg/Ticket/data';
import { makeIcon } from '../makeIcon';

export const Ticket = makeIcon(data, 'ticket', 'Ticket');

export default Ticket;
